export default __webpack_public_path__ + "static/media/bwin.773bc8f8.png";